import { m } from '@aimfora/i18n'
import { createFileRoute, Link, notFound, Outlet } from '@tanstack/react-router'
import { AdminNav } from '~/components/admin/admin-nav'
import { PageHeader } from '~/components/app-shell'

/** Platform admins only. Anyone else sees the same page as for an address that does not exist. */
export const Route = createFileRoute('/_authed/_admin')({
  beforeLoad: ({ context }) => {
    if (!context.session.user.platformAdmin) throw notFound()
  },
  component: AdminLayout,
  notFoundComponent: Forbidden,
})

function AdminLayout() {
  return (
    <>
      <AdminNav />
      <Outlet />
    </>
  )
}

function Forbidden() {
  return (
    <>
      <PageHeader title={m.forbidden_title()} description={m.forbidden_body()} />
      <Link to="/app" className="font-medium text-sm underline underline-offset-2">
        {m.forbidden_back()}
      </Link>
    </>
  )
}
